<template>
  <div class="d-flex flex-column">
    <div
      class="progress-container"
      :class="isTrafficModal ? 'pa-6 pt-3 pb-2' : ''"
      style="width: 100%"
      :style="customHeight ? 'height:' + customHeight + 'px;' : 'height: 100%;'"
    >
      <div
        class="total-progress"
        @mousemove="hover"
        @mouseleave="isHover = false"
        ref="totalProgress"
      >
        <div
          v-for="(item, key, index) in items"
          :key="key"
          class="progress"
          v-show="isTrafficModal || showEstimated"
          :class="'d-flex align-center used-space ' + item.category"
          :data-length="item.length"
          :data-category="item.category"
          :style="getCurrentBarStyle(index, items, item, key)"
        >
          <template v-if="isAnalyticsPage">
            <progress-bar-percentage :category="item" v-if="key !== 1" />
            <progress-bar-percentage
              :category="item"
              v-else-if="item.percentage !== 0"
            />
          </template>
          <p
            class="used-length px-1"
            v-if="key === 0"
            v-show="
              isTrafficModal && !hideUsedText && shouldShowPercentage(key)
            "
            ref="usedLength"
          >
            {{ Number(item.percentage).toFixed(0) }}%
          </p>
          <p
            class="used-length px-1"
            v-else
            v-show="isTrafficModal && shouldShowPercentage(key)"
            ref="usedLength"
          >
            {{ Number(item.percentage).toFixed(0) }}%
          </p>
        </div>
        <div
          class="total-line total-indicator"
          ref="totalLine"
          :style="getTotalTopLineStyle()"
          v-if="isTrafficModal"
        >
          <p
            :style="
              getRemainingPercentage() <= 0 && getRemainingPercentage() >= -5
                ? 'transform: rotate(-90deg); right: 0; left: unset;'
                : 'transform: rotate(90deg); right: unset; left: 0'
            "
            class="total-indicator"
            v-if="isTrafficModal"
          >
            {{ $t('message.progressBar.totalWord') }}
          </p>
        </div>
        <template v-if="splitLine">
          <div
            ref="splitLine"
            class="split-line"
            :style="getSplitLineStyle()"
          />
        </template>
        <div
          class="progress d-flex align-center justify-center used-space"
          :data-length="totalLength"
          :data-category="$t('message.progressBar.hiredWord')"
          style="background: var(--v-progressBar-lighten-1)"
          :style="getTotalStyle()"
        >
          <progress-bar-percentage
            v-if="isAnalyticsPage"
            :category="{
              category: $t('message.progressBar.hiredWord'),
              percentage: 0,
              length: totalLength,
            }"
          />
          <p
            v-if="
              isTrafficModal &&
              usedInfo.percentage == 0 &&
              estimatedInfo.percentage == 0
            "
            class="used-length px-1"
          >
            {{ totalLength }} {{ $t('message.progressBar.hiredWord') }}
          </p>
        </div>
        <div class="details" ref="details" v-show="isHover && isTrafficModal">
          <div class="container-details">
            <div class="top-triangle" ref="topTriangle"></div>
            <p class="ma-0 d-flex flex-row">
              <caption-graph
                :isEstimated="isDescriptionCaptionStripped"
                :captionText="''"
                :backgroundColor="getDescriptionColor"
              />
              <b>{{ description }}</b
              >{{ descriptionLength }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-end align-center" v-if="isTrafficModal">
      <div class="d-flex justify-space-between" style="width: 100%">
        <div class="d-flex">
          <caption-graph
            class="pl-6"
            :isEstimated="false"
            :captionText="
              $t('message.progressBar.usedWord') + ` (${usedInfo.length})`
            "
            :backgroundColor="usedColor"
          />
          <caption-graph
            class="pl-6"
            :isEstimated="true"
            :captionText="
              $t('message.progressBar.estimatedWord') +
              ` (${estimatedInfo.length})`
            "
            :backgroundColor="estimatedColor"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="
                  getRemainingPercentage() <= 0 ? 'red' : 'var(--alert-color)'
                "
                style="margin-top: -1px"
                class="mx-1 mr-2"
                size="20px"
                v-bind="attrs"
                v-on="on"
                v-show="getRemainingPercentage() <= 10"
              >
                mdi-alert
              </v-icon>
            </template>
            <span>{{ $t('message.progressBar.limitMessage') }}</span>
          </v-tooltip>
          <caption-graph
            class="pl-6"
            :isEstimated="false"
            :captionText="getBottomInfo + ' (' + getBottomInfoLength + ')'"
            backgroundColor="var(--v-progressBar-base)"
          />
        </div>
        <div class="hire-more-button-container">
          <v-btn
            style="margin-bottom: 1px"
            color="var(--v-primary-base)"
            elevation="1"
            small
            @click="handleOpenAddonsModal"
          >
            <span style="color: white">{{
              $t('message.progressBar.hireMore')
            }}</span>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import i18n from '@/translations/lang'
import CaptionGraph from '@/components/CaptionGraph.vue'
import ProgressBarPercentage from './ProgressBarPercentage.vue'

export default {
  name: 'ProgressBar2',
  props: [
    'items',
    'totalLength',
    'isTrafficModal',
    'customHeight',
    'dontShowEstimatedLine',
    'isAnalyticsPage',
    'showEstimated',
    'splitLine',
  ],
  components: {
    CaptionGraph,
    ProgressBarPercentage,
  },
  data: () => ({
    description: '',
    descriptionLength: '',
    hideUsedText: false,
    isHover: false,
    usedColor: '',
    estimatedColor: '',
  }),
  methods: {
    ...mapMutations('user', ['UPDATE_ONLY_CUSTOMIZING']),
    shouldShowPercentage(key) {
      if (key === 0) {
        return this.items[key].percentage >= 10 ? true : false
      } else {
        return this.items[key].percentage - this.items[key - 1].percentage >= 10
          ? true
          : false
      }
    },
    getCurrentBarStyle(index, items, item, key) {
      let currentItem = items[key]
      let previousItem = items[key - 1]
      let nextItem = items[key + 1]
      let finalStyle = `z-index: ${items.length - key};`
      let customStripDimensions = this.customStripSize
        ? this.customStripSize + 'px'
        : '40px'

      if (key === 0) {
        if (nextItem?.percentage >= 100) {
          let calc = nextItem.percentage / currentItem.percentage
          let finalCalc = 100 / calc

          if (finalCalc < 2) {
            finalCalc = 1
            this.hideUsedText = true
          } else if (finalCalc <= 7) this.hideUsedText = true

          finalStyle += `min-width: ${finalCalc > 100 ? 100 : finalCalc}%;`
        } else {
          finalStyle += `min-width: ${
            currentItem.percentage > 100 ? 100 : currentItem.percentage
          }%;`
        }
        if (currentItem.percentage >= 90) {
          if (currentItem.percentage >= 100) {
            finalStyle += 'background: var(--danger-color);'
            this.usedColor = 'var(--danger-color)'
          } else {
            finalStyle += 'background: var(--alert-color);'
            this.usedColor = 'var(--alert-color)'
          }
        } else {
          this.usedColor = 'var(--v-primary-base)'
        }
        if (currentItem.percentage < 2) finalStyle += 'min-width: 2%;'
      } else if (key === 1) {
        if (currentItem.percentage < 2) finalStyle += 'min-width: 2%;'
        if (currentItem.percentage >= 90) {
          if (currentItem.percentage >= 100) {
            finalStyle += `width: ${100}%; background: var(--v-progressBar-base); background: var(--v-progressBar-base);`

            if (
              currentItem.category ===
              i18n.t('message.progressBar.estimatedWord')
            ) {
              finalStyle +=
                'background: var(--danger-background-estimated-color); background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 25%, transparent 0, transparent 50%, rgba(255, 255, 255, 0.25) 0, rgba(255, 255, 255, 0.25) 75%, transparent 0, transparent); background-size: ' +
                customStripDimensions +
                ' ' +
                customStripDimensions +
                ';'
              this.estimatedColor = 'var(--danger-background-estimated-color)'
            }
            finalStyle += 'background: var(--danger-color);'
            this.estimatedColor = 'var(--danger-color)'
          } else {
            finalStyle += `width: ${
              currentItem.percentage - previousItem.percentage
            }%; background: var(--v-progressBar-base);`
            finalStyle += 'background: var(--alert-color);'
            this.estimatedColor = 'var(--alert-color)'
          }
        } else {
          finalStyle += `background: var(--v-progressBar-darken1); width: ${currentItem.percentage}%`
          this.estimatedColor = 'var(--v-progressBar-darken1)'
        }
      }

      return finalStyle
    },

    getTotalStyle() {
      return 'width: 100%'
    },
    getRemainingPercentage() {
      return 100 - this.estimatedInfo.percentage
    },
    getSplitLineStyle() {
      let style = ''
      let {
        percentage: splitLineLeftPercentage,
        color: splitLineColor,
        width: splitLineWidth,
      } = this.splitLine
      if (!splitLineColor) splitLineColor = 'white'
      if (!splitLineWidth) splitLineWidth = 2
      if (!splitLineLeftPercentage) splitLineLeftPercentage = 0

      if (splitLineLeftPercentage <= splitLineWidth) {
        style += 'left: 0px;'
      } else {
        style += `left: calc(${splitLineLeftPercentage}% - ${splitLineWidth}px);`
      }
      style += `border-left: ${splitLineWidth}px solid ${splitLineColor};`
      return style
    },
    getTotalTopLineStyle() {
      let initialStyle
      let finalStyle
      let leftPercent

      if (this.getRemainingPercentage() <= 0) {
        leftPercent = (100 / this.estimatedInfo.percentage) * 100

        if (leftPercent >= 100) {
          leftPercent = 99.7
        }

        initialStyle = `visibility: visible; right: unset; left: ${leftPercent}%;`
      }

      if (this.usedInfo.percentage <= 100) {
        initialStyle += 'opacity: 1;'
      } else {
        initialStyle += 'opacity: 0.5;'
      }

      if (this.isTrafficModal) {
        let firstItemCategory = this.usedInfo.category
        let secondItemCategory = this.estimatedInfo.category

        let firstItem = document.querySelector(
          '.traffic-modal-bar .' + firstItemCategory
        )
        let secondItem = document.querySelector(
          '.traffic-modal-bar .' + secondItemCategory
        )

        let firstItemWidth
        let secondItemWidth

        if (firstItem && secondItem) {
          firstItemWidth = Number(firstItem.style.minWidth.replace('%', ''))
          secondItemWidth = Number(secondItem.style.width.replace('%', ''))
          if (secondItemWidth === 100) secondItemWidth = 100 - firstItemWidth
        }
      }

      return initialStyle + finalStyle
    },
    hover(event) {
      if (
        (this.isTrafficModal &&
          (event.target.classList.contains('progress') ||
            event.target.classList.contains('total-indicator'))) ||
        event.target.classList.contains('line-info') ||
        event.target.classList.contains('used-length')
      ) {
        this.isHover = true
        let target = event.target
        let category = target.getAttribute('data-category')
        let length = target.getAttribute('data-length')

        if (length && category !== null) {
          this.description = `${category}`
          this.descriptionLength = `: ${length}`
        }

        let details = this.$refs.details
        let { layerX, layerY } = event
        let detailsWidth = details.getBoundingClientRect().width
        let totalProgressWidth =
          this.$refs.totalProgress.getBoundingClientRect().width
        let top = layerY + 10
        let left

        if (!category || !length) {
          return
        }

        if (layerX <= (detailsWidth / 2).toFixed(0)) {
          layerX === 0
            ? (this.$refs.topTriangle.style.left = '0px')
            : (this.$refs.topTriangle.style.left = `${
                layerX - 10 < 0 ? 0 : layerX - 10
              }px`)
          left = 0
        } else if (layerX + detailsWidth / 2 >= totalProgressWidth) {
          this.$refs.topTriangle.style.left = 'unset '
          this.$refs.topTriangle.style.right = `${
            totalProgressWidth - layerX - 10 >= 0
              ? totalProgressWidth - layerX - 10
              : 0
          }px`
          left = totalProgressWidth - detailsWidth
        } else {
          left = layerX - detailsWidth / 2
          this.$refs.topTriangle.style.left = 'calc(50% - 10px)'
        }

        details.style.top = top + 'px'
        details.style.left = left + 'px'
      } else {
        this.isHover = false
      }
    },
    handleOpenAddonsModal() {
      this.$emit('closeModal')
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
  },
  computed: {
    ...mapState({
      planInfo: (state) => {
        return state.user.userPlanInfo.subscription.name
      },
    }),
    getTopInfo() {
      return this.items[this.items.length - 1].category
    },
    getTopInfoLength() {
      return this.items[this.items.length - 1].length
    },
    getBottomInfo() {
      return i18n.t('message.progressBar.hiredWord')
    },
    getBottomInfoLength() {
      return this.totalLength
    },
    getDescriptionColor() {
      if (this.description === i18n.t('message.progressBar.usedWord'))
        return this.usedColor
      if (this.description === i18n.t('message.progressBar.estimatedWord'))
        return this.estimatedColor
      return 'var(--v-progressBar-base)'
    },
    isDescriptionCaptionStripped() {
      if (this.description === i18n.t('message.progressBar.estimatedWord'))
        return true
      return false
    },
    usedInfo() {
      return this.items[0]
    },
    estimatedInfo() {
      return this.items[1]
    },
  },
  mounted() {
    if (!this.dontShowEstimatedLine) {
      if (this.isTrafficModal) {
        this.$refs.totalLine.style = this.getTotalTopLineStyle()
      }

      if (this.splitLine) {
        this.$refs.splitLine.style = this.getSplitLineStyle()
      }
    }

    this.usedSpaceWidth = Number(
      document.querySelector('.used-space').style.minWidth.replace('%', '')
    )

    this.$emit('mounted')
  },
}
</script>

<style scoped>
.details {
  cursor: auto;
  z-index: 3;
  position: absolute;
  color: #000000;
  background: white;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.144);
  display: flex;
  justify-content: center;
  width: max-content;
}

.container-details {
  position: relative;
  padding: 10px 15px;
}

.top-triangle {
  position: absolute;
  left: calc(50% - 10px);
  top: -14px;
  height: 18px;
  width: 20px;
  clip-path: polygon(50% 50%, 0% 100%, 100% 100%);
  background: white;
}

.total-progress {
  position: relative;
  background: var(--v-progressBar-base);
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  border-radius: 16px;
}

.total-progress * {
  border-radius: 16px;
}

.progress {
  color: #fff;
  text-align: center;
  list-style: '';
  width: 0;
  display: block;
  position: absolute;
  top: 0px;
  transition: width 0.3s;
  background: var(--v-primary-base);
  height: 100%;
}

.line-info-container {
  position: relative;
  height: 100%;
}

.line-info {
  color: transparent;
  position: absolute;
  right: 0px;
  width: 0px;
  border-right: 1px solid rgb(149, 160, 255);
  height: 100%;
}

.top-line-info {
  display: flex;
  align-items: center;
  cursor: auto;
  width: max-content;
  position: absolute;
  top: -26px;
  color: black;
}

.top-line-info.total {
  right: -2px;
  border-left: none;
  padding-right: 10px;
  border-right: 3px dotted black;
}

.used-length {
  cursor: text;
  color: white;
  width: fit-content;
  line-height: normal;
  margin-bottom: 0 !important;
  text-shadow: 0px 0px 9px #0000006e;
  font-weight: 700;
  transition: opacity 0.3s;
}

.bottom-info {
  cursor: auto;
}

.yellow2--text {
  color: var(--alert-color) !important;
}

.alert-color {
  background: var(--alert-color) !important;
}

.danger-color {
  background: var(--danger-color) !important;
}

.bolder {
  font-weight: 500;
}

.total-line {
  position: absolute;
  top: 0;
  width: 0;
  height: 100%;
  border-left: 3px dotted white;
  transition: opacity 0.3s;
  opacity: 0.5;
  right: 10px;
  visibility: hidden;
  z-index: 3;
}
.split-line {
  position: absolute;
  top: 0;
  width: 0;
  height: 100%;
  border-left: 2px solid white;
  right: 0;
  visibility: visible;
}

.total-line p {
  margin: 0;
  margin-top: 0px;
  font-size: 12px;
  margin-top: 10px;
  position: absolute;
  cursor: default;
}

.hire-more-button-container {
  margin-right: 24px;
}
</style>
